export const monthsShort = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
export const monthsLong = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

export const monthNumberToLabel = (monthNumber, labels = null) => {
  if (!Number.isInteger(monthNumber)) {
    return '';
  }

  if (monthNumber < 1 || monthNumber > 12) {
    return '';
  }

  if (labels === null) {
    labels = monthsShort;
  }

  return labels[monthNumber - 1];
};
